import { ArrowBack } from "@mui/icons-material";
import { Grid, IconButton, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import MuiButton from "../../../components/muibutton";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { getAPI } from "../../../services/basehttpAPI";
import SnackbarComponent from "../../../components/snackbar";
const ViewCustomShipToParty = () => {
    const translatedText = JSON.parse(sessionStorage.getItem("TranslationText"));
    const location = useLocation();
    const isEditCustomShipToPartyRedirect = location.state?.isEditCustomShipToPartyRedirect || false;
    const params = useParams();
    const id = params.id;
    const [shipToPartyDetails, setShipToPartyDetails] = useState({});
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [severity, setSeverity] = useState("");
    const navigate = useNavigate();
    useEffect(() => {
        getShipToPartyDetails();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isEditCustomShipToPartyRedirect) {
            setOpen(true);
            setSeverity("success");
            setMessage(translatedText?.custom_ship_to_name_update_success);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isEditCustomShipToPartyRedirect]);

    const getShipToPartyDetails = async () => {
        let url = `ShipToParty/GetShipToPartyDetailById?customerShipToPartyId=${id}`;
        const response = await getAPI(url, null);
        setShipToPartyDetails(response?.responseData);
    };
    const handleNavigation = () => {
        let navigationUrl = `/layout/editcustomshiptoparty/${id}`;
        navigate(navigationUrl);
    }
    const handleClose = () => {
        setOpen(false);
    };
    const handleBack = (e) => {
        e.preventDefault();
        navigate("/layout/customerprofiles?tab=1");
    };
    return (
        <Container maxWidth="lg">
            <Typography variant="h5" flexGrow={1} sx={{ pl: "24px" }}>
                {translatedText?.view_shiptoparty_name}
            </Typography>
            <Paper
                sx={{
                    width: "80%",
                    mt: "20px",
                    ml: "20px",
                    mb: "20px",
                }}
            >
                <Box sx={{ height: "60px", backgroundColor: "#F4F7FC" }}>
                    <Stack
                        useFlexGap
                        flexWrap="wrap"
                        direction="row"
                        spacing={{ xs: 0.5, sm: 2, md: 4 }}
                        sx={{ paddingTop: "10px", mr: "10px" }}
                    >
                        <IconButton onClick={handleBack}>
                            <ArrowBack />
                        </IconButton>
                        <Typography variant="h6" flexGrow={1} sx={{ pt: "5px" }}>
                            {shipToPartyDetails?.shipToName}
                        </Typography>
                        <MuiButton
                            type="button"
                            text={translatedText.edit}//"Edit"
                            color="warning"
                            onClick={handleNavigation}
                            show={true}
                        />
                    </Stack>
                </Box>
                <Grid container spacing={2} sx={{ m: "20px" }}>
                    <Grid item xs={12} sm={12} md={3}>
                        <span className="fontcolor label-txt">
                            {shipToPartyDetails?.shipToName}
                        </span>
                        <div className="fontheadercolor label-txt">{translatedText?.ship_to_name}</div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={3}>
                        <span className="fontcolor label-txt">{shipToPartyDetails?.customShipToName}</span>
                        <div className="fontheadercolor label-txt">{translatedText?.custom_ship_to_name}</div>
                    </Grid>
                </Grid>
            </Paper>
            <SnackbarComponent
                open={open}
                handleClose={handleClose}
                message={message}
                severity={severity}
            />
        </Container>
    );
};

export default ViewCustomShipToParty;